import {
    HighlandRecordType,
    HighlandRecordSubType
} from "./HighlandRecordTypes";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from 'ol/style/RegularShape';
import * as olHas from 'ol/has';

export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {
                case HighlandRecordSubType.ConservationArea:
                    style = this.ConservationArea();
                    break;

                case HighlandRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case HighlandRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;

                case HighlandRecordSubType.HistoricBattlefield:
                    style = this.RegisteredBattlefield();
                    break;

                case HighlandRecordSubType.HistoricMarineProtectedArea:
                    style = this.MarineProtectedArea();
                    break;

                case HighlandRecordSubType.DesignedLandscape:
                    style = this.DesignedLandscape();
                    break;
            }

        }

        if (style === null) {
            switch (recordType) {
                case HighlandRecordType.Monument:
                    style = this.Monument();
                    break;

                case HighlandRecordType.Event:
                    style = this.Event();
                    break;

                case HighlandRecordType.Designation:
                    style = this.Designation();
                    break;

                case HighlandRecordType.FlowCountryWorldHeritageSite:
                    style = this.WorldHeritageSite();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(recordType: HighlandRecordType): Style[] {
        let style: Style[] = null;

        switch (recordType) {
            case HighlandRecordType.Monument:
                style = this.MonumentSelected();
                break;

            case HighlandRecordType.Event:
                style = this.EventSelected();
                break;

            case HighlandRecordType.Designation:
                style = this.DesignationSelected();
                break;
        }

        return style;
    }

    private CommonStyle(fillColour: string): Style[] {
        var fill = new Fill({
            color: fillColour
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,255,1)',
            width: 3
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }


    private Monument(): Style[] {
        //let s = this.CommonStyle('rgba(185, 107, 225,0.5)');
        //s[0].setStroke(new Stroke({
        //    color: 'rgba(185, 107, 225,1)',
        //    width: 3
        //}));

        //return s;
        // new
        var fill = new Fill({
            color: 'rgba(185, 107, 225, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(185, 107, 225, 1)',
            width: 2
        });

        return [new Style({
            image: new Circle({
                fill: new Fill({ color: 'rgba(185, 107, 225, 1)' }),
                stroke: new Stroke({ color: 'rgba(50, 50, 50, 1)', width: 1 }),
                radius: 4
            }),
            fill: fill,
            stroke: stroke
        })];

    }

    private Event(): Style[] {
        //return this.CommonStyle('rgba(241, 171, 0, 0.4)');    
        var fill = new Fill({
            color: 'rgba(241, 171, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(241, 171, 0, 1)',
            width: 2
        });
        return [new Style({
            image: new Circle({
                fill: new Fill({ color: 'rgba(241, 171, 0, 1)' }),
                stroke: new Stroke({ color: 'rgba(50, 50, 50, 1)', width: 1 }),
                radius: 4
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15,0.4)');
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(226, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(50, 50, 50, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ConservationArea(): Style[] {
        //return this.CommonStyle('rgba(27, 15, 220, 0.4)');   
        var fill = new Fill({
            color: 'rgba(27, 15, 220, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(27, 15, 220, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ScheduledMonument(): Style[] {
        var fill = new Fill({
            color: 'rgba(226, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(226, 0, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private DesignedLandscape(): Style[] {
        //return this.CommonStyle('rgba(45, 123, 9,0.5)');   
        var fill = new Fill({
            color: 'rgba(45, 123, 9, 0.4)'
        });

        var stroke = new Stroke({
            color: 'rgba(45, 123, 9, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private RegisteredBattlefield(): Style[] {
        //return this.CommonStyle('rgba(239, 26, 28,0.5)');            
        // Generate a canvasPattern
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var p = document.createElement('canvas');
        // Gradient and pattern are in canvas pixel space, so we adjust for the
        // renderer's pixel ratio
        var pixelRatio = olHas.DEVICE_PIXEL_RATIO;
        var pattern = (function () {
            canvas.width = 32 * pixelRatio;
            canvas.height = 16 * pixelRatio;
            // background
            context.fillStyle = "rgba(239, 26, 28, 0.1)";
            context.fillRect(0, 0, canvas.width, canvas.height);

            var x0 = 36;
            var x1 = -4;
            var y0 = -2;
            var y1 = 18;
            var offset = 32;

            context.strokeStyle = "rgba(239, 26, 28, 1)";
            context.lineWidth = 1;
            context.beginPath();
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.moveTo(x0 - offset, y0);
            context.lineTo(x1 - offset, y1);
            context.moveTo(x0 + offset, y0);
            context.lineTo(x1 + offset, y1);
            context.stroke();

            context.fillStyle = context.createPattern(canvas, 'repeat');
            context.fillRect(0, 0, canvas.width, canvas.height);

            return context.createPattern(canvas, 'repeat');
        }());
        var fill = new Fill({
            color: 'rgba(239, 26, 28, 0.4)'
        });
        fill.setColor(pattern);

        var stroke = new Stroke({
            color: 'rgba(239, 26, 28, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: new Fill({ color: 'rgba(239, 26, 28, 0.4)' }),
                stroke: stroke,
                points: 3,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private MarineProtectedArea(): Style[] {
        //return this.CommonStyle('rgba(132, 71, 15, 0.4)');
        var fill = new Fill({
            color: 'rgba(132, 71, 15, 0.4)'
        });

        var stroke = new Stroke({
            color: 'rgba(132, 71, 15, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private WorldHeritageSite(): Style[] {
        //return this.CommonStyle('rgba(132, 71, 15, 0.4)');
        var fill = new Fill({
            color: 'rgba(132, 132, 132, 0.4)'
        });

        var stroke = new Stroke({
            color: 'rgba(100, 100, 100, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private MonumentSelected(): Style[] {
        var fill = new Fill({
            color: 'rgba(63, 211, 0, 0.6)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(76, 255, 0, 0.6)',
                        width: 5
                    }),
                    radius: 12
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(76, 255, 0, 0.6)',
                    width: 5
                })
            })
        ];
    }

    private EventSelected(): Style[] {
        return this.MonumentSelected();
    }

    private DesignationSelected(): Style[] {
        return this.MonumentSelected();
    }

}
